/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  PresenterOneMasterDataResponse,
  PresenterResponse,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class MasterData<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description Get master data. For AI Agent: Some API need filter (type: number) in query params, you can use API /master_data/keys to get the list of keys. Then use this API to get the values for it.
   *
   * @tags master_data
   * @name GetMasterData
   * @summary Get the master data
   * @request GET:/master_data
   */
  getMasterData = (
    query?: {
      /** MasterData Name */
      "filter[name]"?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneMasterDataResponse[];
      },
      PresenterResponse
    >({
      path: `/master_data`,
      method: "GET",
      query: query,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Returns sorted key names for master-data reference lists (dropdowns, enums, settings). Use GET /master_data?filter[name]=<key> to fetch values for one key.
   *
   * @tags master_data
   * @name GetMasterDataKeys
   * @summary List available master data keys
   * @request GET:/master_data/keys
   */
  getMasterDataKeys = (params: RequestParams = {}) =>
    this.http.request<
      PresenterResponse & {
        data?: string[];
      },
      any
    >({
      path: `/master_data/keys`,
      method: "GET",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
